module.exports = __webpack_public_path__ + "static/media/pie.da1d40cb.svg";